import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BreadcrumbService } from './shared/components/breadcrumb/breadcrumb.service';
import { environment } from '../environments/environment';
// import 'rxjs/add/operator/filter';
import { Utilities } from '../modules/shared/utilities';
import { TCCPConstantValues } from './shared/models/tccp-constants';
import { TCCPLocalStorageService } from './shared/services/tccp-local-storage.service';
import { TCCPCommonService } from './shared/services/tccp-common.service';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { parse } from 'url-parse';
import { filter } from 'rxjs/operators';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'TCCP';
  public appURl = '';

  constructor(
    private translate: TranslateService,
    private msalBroadcastService: MsalBroadcastService,
    private titleService: Title, private router: Router,
    private authService: MsalService,
    @Inject(DOCUMENT) private document: HTMLDocument,
    private storageService: TCCPLocalStorageService, private breadcrumbService: BreadcrumbService,
    private commonService: TCCPCommonService) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit() {

    this.msalBroadcastService.msalSubject$.pipe(
      filter((message: EventMessage) => message.eventType === EventType.LOGIN_SUCCESS),
    )
    .subscribe((message: EventMessage) =>{
      const authResult = message.payload as AuthenticationResult;
      if(authResult !== undefined && authResult !== null){
            var token = JSON.stringify({token:authResult?.idToken})
            this.storageService.setToken(token);
            var expiresOn = JSON.stringify({expiresOn:authResult?.expiresOn})
            this.storageService.setTokenExpiry(expiresOn);
          }

      this.authService.instance.setActiveAccount(authResult.account);
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    })
    let siteType: string = null;
    let division: string = null;
    let modelQueryParam: string = null;
    let modelYearParam: string = null;
    this.storageService.setFromDashboard(false);

    // Deep link scenario in support topic page flow
    const link = Utilities.getQueryString('link', this.appURl);
    if (link) {
      modelQueryParam = this.storageService.getVehicleModel().name;
      modelYearParam = this.storageService.getVehicleYear().name;
    }

    if (window.performance && window.performance.navigation.type === 0) {
      this.storageService.clearStorage();
      this.storageService.clearFlow();
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
  ).subscribe(event => {
      const urlKey = 'url';
      this.appURl = Utilities.GetPath(event[urlKey]);
    });

    if (environment.applicationName === '') {
      this.appURl = window.location.href;
      if (link) {
        this.appURl = this.appURl + '&model=' + modelQueryParam
          + '&year=' + modelYearParam;
      }
      division = window.location.href;
      environment.applicationName = Utilities.GetPath(window.location.pathname);
    }
    if (environment.applicationName != null) {
      division = environment.applicationName;
      /* Clear Local storage (Model,Year & VIN on refresh ad reload on home page) */

      if (this.appURl.includes('/' + division + '/home')) {
        if (this.appURl && window.location.search === '') {
          if (window.performance && (window.performance.navigation.type === 1)) {
            this.storageService.clearStorage();
            this.storageService.clearFlow();
          }
        }
      }
      /* Admin routing */
      if (this.appURl.includes('/admin')) {
        this.router.navigate(['admin']);
        this.titleService.setTitle(TCCPConstantValues.base.url_contexts.ADMIN_TITLE);
      } else if (this.appURl.includes(TCCPConstantValues.base.url_contexts.TOYOTA_EXTERNAL)
      /* || this.appURl.includes('qa.toyotaaudioandconnectedservicessupport')*/) {  /* Toyota External routing */
        this.setRouting('toyota', 'external', link, TCCPConstantValues.base.url_contexts.TOYOTA_TITLE);
      } else if (this.appURl.includes(TCCPConstantValues.base.url_contexts.TOYOTA_INTERNAL)
      /* || this.appURl.includes('qa.connectedtechnologiestoyota') */) { /* Toyota Internal Routing */
        this.setRouting('toyota', 'internal', link, TCCPConstantValues.base.url_contexts.TOYOTA_TITLE);
      } else if (this.appURl.includes(TCCPConstantValues.base.url_contexts.LEXUS_EXTERNAL)
      /* || this.appURl.includes('qa.lexusconnectedtechnologysupport') */) { /* Lexus External Routing */
        this.setRouting('lexus', 'external', link, TCCPConstantValues.base.url_contexts.LEXUS_TITLE);
      } else if (this.appURl.includes(TCCPConstantValues.base.url_contexts.LEXUS_INTERNAL)
      /* || this.appURl.includes('qa.connectedtechnologieslexus') */) {  /* Lexus Internal Routing */
        this.setRouting('lexus', 'internal', link, TCCPConstantValues.base.url_contexts.LEXUS_TITLE);
      } else if (this.storageService.getFeatureType() === 'internal') { // Local Internal routing
        this.setLocalRouting();
      } else {  // Local External routing
        this.setLocalRouting();
      }
    }

    siteType = this.storageService.getFeatureType() === 'internal' ? 'internal' : 'external';

    const title = this.appURl.includes('toyota') ? TCCPConstantValues.base.url_contexts.TOYOTA_TITLE :
      this.appURl.includes('lexus') ? TCCPConstantValues.base.url_contexts.LEXUS_TITLE : '';
    this.titleService.setTitle(title);
    this.commonService.setGTagEventDetails('Division', division, 'Division');
    this.commonService.setGTagEventDetails('Sitetype', siteType, 'Sitetype');
    const envPath = environment.applicationName === 'toyotaguide' ? 'toyota' : environment.applicationName === 'lexusguide' ?
      'lexus' : environment.applicationName;
    console.log('environment.applicationName favicon', environment.applicationName, envPath);

    this.document.getElementById('appFavicon').setAttribute('href', 'assets/images/' +
      envPath.toLowerCase() + '/favicon.ico');
  }

  setLocalRouting() {
        /* Redirecton from CTP Admin Portal TCCP-1631 */
    if (this.appURl.includes('vin') && this.appURl.includes('issueId') &&
      this.appURl.includes('source') && this.appURl.includes('featName')) {
      this.redirectToFeatureByVIN();
    } else if (this.appURl.includes('vin') && this.appURl.includes('year') &&
      this.appURl.includes('model')) {
      this.redirectToDashboard();
    } else if (this.appURl.includes('feature') || this.appURl.includes('dashboard')) {
      this.storageService.setFeatureType('');
      if (this.appURl.includes('feature')) {
        this.redirectionURL();
      } else {
        this.router.navigate([`${environment.applicationName}/dashboard`]);
      }
    } else if (this.appURl.includes('year') && this.appURl.includes('model')) {
      if (this.appURl.includes('feature')) {
        this.redirectionURL();
      } else {
        this.redirectToDashboard();
      }
    } else if (this.appURl.includes('toyotaguide/home')) {
      console.log('test setup');
      this.storageService.setFeatureType('');
    } else if (this.appURl.includes('toyotaguide/home/internal')) {
      console.log('test setup');
      this.storageService.setFeatureType('internal');
    } else if (this.appURl.includes('lexusguide/home')) {
      console.log('test setup');
      this.storageService.setFeatureType('');
    } else if (this.appURl.includes('lexusguide/home/internal')) {
      console.log('test setup');
      this.storageService.setFeatureType('internal');
    } else if (this.appURl.includes('phone-compatability')) {
      console.log('test phone-compatability');
      this.router.navigateByUrl(`${environment.applicationName}/phone-compatability`);
    } else if (this.appURl.includes('internal')) {
      this.storageService.setFeatureType('internal');
      this.router.navigateByUrl(`${environment.applicationName}/home/internal`);
    } else {
      this.storageService.setFeatureType('');
      this.router.navigateByUrl(`${environment.applicationName}/home`);
    }
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public redirectionURL() {
    /* US TCCP-1608,land on the same step
      when url of that particular step is opened in a new tab.*/
    const tempList = this.appURl.split('/');
    const targetID = tempList[tempList.indexOf('feature') + 2].split('?')[0];
    const featureName = decodeURIComponent(tempList[tempList.indexOf('feature') + 1]);
    this.redirectToFeature(environment.applicationName, featureName, targetID);
  }

  public redirectToDashboard() {
    if (!this.appURl.includes('model') || !this.appURl.includes('year') || !this.appURl.includes('vin')) {
      this.router.navigate([`${environment.applicationName}/dashboard`]);
    } else {
      const division = environment.applicationName;
      const vehicleVin = (Utilities.getQueryString('vin', this.appURl));
      this.storageService.setVehicleVin(vehicleVin, null);
      this.storageService.setSupportTopics('Support Topics', division + '/dashboard');
      this.setHomeURL(division);
      this.router.navigate([`${environment.applicationName}/dashboard`]);
    }
  }

  // Set lexus email pre-requisites for redirection
  public redirectToFeature(division, featureName, stepID) {
    const homeURL = this.storageService.getFeatureType() === 'internal' ? `${division}/home/internal` :
      `${division}/home`;
    const vehicleYear = Utilities.getQueryString('year', this.appURl);
    let vehicleModel = (Utilities.getQueryString('model', this.appURl));
    vehicleModel = vehicleModel ? vehicleModel.replace('%20', ' ') : '';
    this.storageService.setSupportTopics('Support Topics', division + '/dashboard');
    this.storageService.setFeature(featureName.toLowerCase(), null); // need targerID of the suptop for 'linkProp' param
    if (vehicleYear && vehicleYear !== 'null') {
      this.storageService.setFeature(featureName.toLowerCase(), '/' + division + '/feature/'
        + encodeURIComponent(featureName + '/' + stepID + '?model=' + vehicleModel
        + '&year=' + vehicleYear));
      this.storageService.setVehicleYear(Number(vehicleYear), homeURL);
    }
    this.storageService.setVehicleModel(vehicleModel, homeURL);
    this.storageService.setHome(homeURL);
    this.breadcrumbService.showBreadcrumb.emit(true);
    const url = division + '/feature/' + (featureName + '/' + stepID) + '?model=' + vehicleModel + '&year=' + vehicleYear;
    this.router.navigateByUrl(url);
  }

  setModelYearDetails(source, vin, feature, issueId, vehicleModel, year) {
    const homeURL = this.storageService.getFeatureType() === 'internal' ? `${source}/home/internal` :
      `${source}/home`;
    vehicleModel = vehicleModel.replace(new RegExp('%20', 'g'), ' ');
    this.storageService.setVehicleVin(vin, environment.baseURL + source + '/home/internal');
    this.storageService.setFeature(feature.toLowerCase(), '/' + source + '/feature/'
      + encodeURIComponent(feature + '/' + issueId + '?model=' + vehicleModel
      + '&year=' + year));
    this.storageService.setSupportTopics('Support Topics', source + '/dashboard');
    this.storageService.setVehicleYear(Number(year), homeURL);
    this.storageService.setVehicleModel(vehicleModel, homeURL);
    this.storageService.setHome(homeURL);
    this.breadcrumbService.showBreadcrumb.emit(true);
    const url = `${source}/feature/${feature}/${issueId}?model=${vehicleModel}&year=${year}`;
    this.router.navigateByUrl(url);
  }

  /* Redirecton from CTP Admin Portal TCCP-1631 */
  public redirectToFeatureByVIN() {
    const issueId = Utilities.getQueryString('issueId', this.appURl);
    let model = (Utilities.getQueryString('model', this.appURl));
    const year = (Utilities.getQueryString('year', this.appURl));
    let feature = (Utilities.getQueryString('featName', this.appURl));
    const vehicleVin = (Utilities.getQueryString('vin', this.appURl));
    const source = (Utilities.getQueryString('source', this.appURl));
    model = model.replace('%20', ' ');
    feature = feature.replace('%C2%AE', '®');
    this.setModelYearDetails(source, vehicleVin, feature, issueId, model, year);
  }

  setHomeURL(source) {
    const homeURL = this.storageService.getFeatureType() === 'internal' ? `${source}/home/internal` :
      `${source}/home`;
    const vehicleYear = Utilities.getQueryString('year', this.appURl);
    let vehicleModel = (Utilities.getQueryString('model', this.appURl));
    vehicleModel = vehicleModel.replace('%20', ' ');
    const vehicleVin = (Utilities.getQueryString('vin', this.appURl));
    this.storageService.setHome(homeURL);
    this.storageService.setVehicleYear(Number(vehicleYear), homeURL);
    this.storageService.setVehicleModel(vehicleModel, homeURL);
    this.storageService.setVehicleVin(vehicleVin, null);
    this.breadcrumbService.showBreadcrumb.emit(true);
  }

  setRouting(source, featureType, link, title) {
    this.commonService.setGTagEventDetails('Entry URL', `${environment.applicationName}`, window.location.href);
    environment.applicationName = source;
    // siteType = 'internal';
    this.titleService.setTitle(title);
    this.storageService.setFeatureType(featureType);
    // added model and year check  for 1305
    if (this.appURl.includes('year') && this.appURl.includes('model') && !this.appURl.includes('vin')) {
      this.setHomeURL(source);
      if (this.appURl.includes('feature')) {
        this.redirectionURL();
      } else if (link) {
        this.document.getElementById('appFavicon').setAttribute('href', 'assets/images/' +
          environment.applicationName.toLowerCase() + '/favicon.ico');
        const parsed = parse(this.appURl);
        this.router.navigateByUrl(parsed.pathname + parsed.query);
      } else {
        this.redirectToDashboard();
      }
    } else if (this.appURl.includes('vin') && this.appURl.includes('issueId') &&
      this.appURl.includes('source') && this.appURl.includes('featName')) { /* Redirecton from CTP Admin Portal TCCP-1631 */
      this.redirectToFeatureByVIN();
    } else if (this.appURl.includes('year') && this.appURl.includes('model') && this.appURl.includes('vin')) {
      this.setHomeURL(source);
    } else if (this.appURl.includes('vin') && this.appURl.includes('source')) {
      this.setReferralData('toyota');
      this.breadcrumbService.showBreadcrumb.emit(true);
      this.router.navigate([`${environment.applicationName}/dashboard`]);
    } else if (this.appURl.includes('year') && this.appURl.includes('model')) {
      this.redirectToDashboard();
    } else if (this.appURl.includes('feature') || this.appURl.includes('dashboard')) {
      this.storageService.setFeatureType(featureType);
      if (this.appURl.includes('feature')) {
        this.redirectionURL();
      } else {
        this.redirectToDashboard();
      }
    } else if (this.appURl.includes(TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE)) {
      this.storageService.setFeatureType(featureType);
      if(featureType === 'internal'){
        this.router.navigateByUrl(`${environment.applicationName}guide/home/internal`);
      }else{
        this.router.navigateByUrl(`${environment.applicationName}guide/home`);
      }
    } else if (this.appURl.includes(TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE)) {
      this.storageService.setFeatureType(featureType);
      if(featureType === 'internal'){
        this.router.navigateByUrl(`${environment.applicationName}guide/home/internal`);
      }else{
        this.router.navigateByUrl(`${environment.applicationName}guide/home`);
      }
    } else if (this.appURl.includes('phone-compatability')) {
      console.log('test phone-compatability');
      this.router.navigateByUrl(`${environment.applicationName}/phone-compatability`);
    } else {
        this.setPageNavigation(source, featureType);
    }
  }

  setPageNavigation(source, featureType) {
    if (featureType === 'internal') {
      this.storageService.setFeatureType('internal');
      this.router.navigate([`${source}/home/internal`]);
    } else {
      this.storageService.setFeatureType('');
      this.router.navigate([`${source}/home`]);
    }
  }

  public setReferralData(appName) {
    const vehicleVin = (Utilities.getQueryString('vin', this.appURl));
    const referralSource = Utilities.getQueryString('source', this.appURl);
    this.storageService.setHome(appName + '/home');
    this.storageService.setVehicleVin(vehicleVin, null);
    this.commonService.setGTagEventDetails('referralSource', '' + referralSource, 'referralSource');
    this.commonService.setGTagEventDetails('OneApp', '' + vehicleVin, 'referralSource');
    this.breadcrumbService.showBreadcrumb.emit(true);
  }

}
